import React, { useEffect, useState, useRef } from 'react';
import Playlist from './Playlist';
import { FloatButton } from 'antd';
import { PlayCircleFilled } from '@ant-design/icons';
import EighthNoteAnimated from "../../images/notes/EighthNoteAnimated";
import DoubleNoteAnimated from "../../images/notes/DoubleNoteAnimated";
import FlashingDot from '../FlashingDot';

const Vinyl = ({ trackedObjects }) => {
  const [open, setOpen] = useState(false);
  const [areNotesVisible, setAreNotesVisible] = useState(false);
  const [vinyl, setVinyl] = useState(null);

  // Use a ref to store the latest value of trackedObjects
  const trackedObjectsRef = useRef(trackedObjects);

  // Update the ref whenever trackedObjects changes
  useEffect(() => {
    trackedObjectsRef.current = trackedObjects;
  }, [trackedObjects]);

  // Set the vinyl object once after the component mounts
  useEffect(() => {
    const newVinyl = trackedObjectsRef.current.find(o => o.name === 'record-player-spindle');
    setVinyl(newVinyl);
  }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOpen(true);
      setAreNotesVisible(true);
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Playlist setOpen={setOpen} open={open} />
      {vinyl && <FlashingDot onClick={setOpen} param={true} position={{ x: vinyl.pos.x, y: vinyl.pos.y + 50 }} />}
      {areNotesVisible && vinyl && (
        <>
          <DoubleNoteAnimated begin={0.7} scale={2} duration={4} color={'white'} position={{ x: vinyl.pos.x, y: vinyl.pos.y - 600 }} />
          <EighthNoteAnimated begin={0} scale={2} duration={3.5} color={'white'} position={{ x: vinyl.pos.x - 150, y: vinyl.pos.y - 750 }} />
          <EighthNoteAnimated begin={0} scale={2} duration={4.5} color={'white'} position={{ x: vinyl.pos.x, y: vinyl.pos.y - 750 }} />
        </>
      )}
      <FloatButton
        icon={<PlayCircleFilled />}
        style={{
          insetInlineEnd: 94,
        }}
        onClick={() => setOpen(true)}
      />
    </>
  );
};

export default Vinyl;